import React from 'react';

import AppNav from '@sophocles/components/App/AppNav';

import { SiteGroupDashboard } from './components';

/**
 * SiteGroupDashboardView - View wrapper for the Site Group Dashboard
 * Shows operational compliance for all sites in a site group
 */
const SiteGroupDashboardView = () => {
  return (
    <AppNav page="plant_compliance" notFullHeight={true}>
      <SiteGroupDashboard />
    </AppNav>
  );
};

export default SiteGroupDashboardView;
